<template>
    <div v-if="item.processing.cropper.data && item.processing.cropper.cropBoxData || +width && +processedHeight"
         class="checkout-order-item">
        <img ref="preview" v-show="cropperReady" :class="`checkout-order-item-img checkout-order-item-img--${getAspectRatio(item, {width: +width, height: +processedHeight}) > 1 ? 'hor' : 'ver'}`" alt="">
        <vue-cropper ref="cropper" :id="`img-${item.productId ? item.productId :item.id}`" class="cropper"
                     :src="item.large_photo" :auto-crop-area="1" :ready="init"
                     :check-orientation="false"
                     :aspect-ratio="getAspectRatio(item, {width: +width, height: +processedHeight}, true)"/>
        <b-spinner v-if="!cropperReady" variant="secondary"/>
    </div>
    <div v-else class="checkout-order-item" :id="`img-${item.productId ? item.productId :item.id}`" :style="`background-image: url(${item.medium_photo})`">
        <img :src="item.medium_photo" class="cropper-hidden" alt="">
    </div>
</template>

<script>
  import VueCropper from 'vue-cropperjs';
  import 'cropperjs/dist/cropper.css';

  export default {
    props: ['item', 'width', 'height'],
    components: {
      VueCropper,
    },
    data() {
      return {
        cropperReady: false,
        processedHeight: this.height,
      };
    },
    methods: {
      init() {
        this.setCropBoxData();
        this.setData();
        this.renderPreview();

        if (this.item.processing.filter) {
            this.applyFilter(this.$refs.preview, this.item.processing.filter);
        }

        this.cropperReady = true;
      },
      setData() {
        const data = this.item.processing.cropper.data;

        if (data) {
          try {
            this.$refs.cropper.setData(data);
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      },
      setCropBoxData() {
        const cropBoxData = this.item.processing.cropper.cropBoxData;

        if (cropBoxData) {
          try {
            this.$refs.cropper.setCropBoxData(this.item.processing.cropper.cropBoxData);
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      },
      renderPreview() {
        const canvas = this.$refs.cropper ? this.$refs.cropper.getCroppedCanvas() : null;
        const base64 = canvas ? canvas.toDataURL('image/jpeg') : '';
        const previewContainer = this.$refs.preview;

        if (previewContainer) {
          previewContainer.setAttribute('src', base64);
          //previewContainer.style.backgroundImage = `url(${base64})`;
        }
      },
    },
    created() {
      if (+this.height === 0) {
        const sizes = JSON.parse(this.item.dimensions);
        this.processedHeight = parseInt(+this.width * +sizes.height / +sizes.width);
      }
    }
  };
</script>

<style lang="scss">

</style>